import generateReportFromView from '@opsbase/lib-data-view/helpers/generateReportFromView';
import isViewMandatory from '@opsbase/lib-data-view/helpers/isViewMandatory';
import sortViews from '@opsbase/lib-data-view/helpers/sortViews';
import DataType from '@opsbase/lib-datatype/DataType';
import doNothing from '@opsbase/lib-general/utils/doNothing';
import { getFromStringOrFunction } from '@opsbase/lib-general/utils/getFromStringOrFunction';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import Palette from '@opsbase/lib-palette';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useReportUpdate from '@opsbase/react-gql-hooks/report/useReportUpdate';
import useAppState from '@opsbase/web-app-state/useAppState';
import useCss from '@opsbase/web-css';
import useView from '@opsbase/web-ctrl-view/useView';
import useViewRegistry from '@opsbase/web-ctrl-view/useViewRegistry';
import useViewRegistryActions from '@opsbase/web-ctrl-view/useViewRegistryActions';
import Pane from '@opsbase/web-layout/Pane';
import useNav from '@opsbase/web-nav/useNav';
import useParams from '@opsbase/web-nav/useParams';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import Tab from '@opsbase/web-tabs/Tab';
import Tabs from '@opsbase/web-tabs/Tabs';
import React, { useCallback, useMemo } from 'react';
const makeMyClasses = isDirty => ({
    root: {
        margin: '4px 16px',
        backgroundColor: Palette.White.main,
        borderRadius: 4,
        height: 40,
        maxWidth: isDirty ? 'calc(100% - 104px)' : '100%',
        '& .MuiTabScrollButton-root': {
            width: 24,
        },
        '& .MuiTab-wrapper': {
            fontSize: 12,
        },
        '& .MuiTab-root': {
            minHeight: 40,
        },
        '& .MuiTabs-root': {
            minHeight: 40,
        },
    },
});
export function ReportsTabs(props) {
    const { viewId } = useParams();
    const { dataType } = props;
    const self = useSelf();
    const { goTo } = useNav();
    const updateReport = useReportUpdate();
    const views = useViewRegistry();
    const currentView = useView(viewId);
    const { raise } = useNotificationActions();
    const { putView } = useViewRegistryActions();
    const { manageReportsOpen } = useAppState();
    const myCss = useCss(makeMyClasses, [!!(currentView === null || currentView === void 0 ? void 0 : currentView.isDirty) && !manageReportsOpen]);
    const handleSave = useCallback(view => () => {
        raise(updateReport({ id: view.id, patch: generateReportFromView(view) }), i18n.t('savedview-save-successful')).catch(doNothing);
    }, [raise, updateReport]);
    const handleReset = useCallback(lmss => () => {
        putView(lmss.cleanLmss);
    }, [putView]);
    const handleChangeTab = useCallback((e, nextViewId) => {
        let page;
        if (dataType === DataType.OP)
            page = Pages.OPS_LOG;
        if (dataType === DataType.ISSUE)
            page = Pages.ISSUES_LOG;
        if (dataType === DataType.OPDEFINITION)
            page = Pages.OP_DEFINITIONS;
        goTo(page, { viewId: nextViewId });
    }, [goTo, dataType]);
    const myViews = useMemo(() => {
        return sortViews(Object.values(views).filter(view => view.type === dataType &&
            !view.isDashboard &&
            (isViewMandatory(view, self) || self.preferences.isFavourite(view.id))), self);
    }, [dataType, self, views]);
    const currentTab = useMemo(() => {
        var _a;
        let ct = (currentView === null || currentView === void 0 ? void 0 : currentView.type) === dataType ? currentView.id : false;
        if (!myViews.find(v => v.id === ct))
            ct = (_a = myViews[0]) === null || _a === void 0 ? void 0 : _a.id;
        return ct;
    }, [currentView, dataType, myViews]);
    return (React.createElement(Pane, { grow: true, classes: { root: myCss.root } },
        React.createElement(Tabs, { variant: "scrollable", scrollButtons: "on", value: currentTab, onChange: handleChangeTab, indicatorColor: "secondary", textColor: "secondary" }, myViews.map((view, idx) => {
            const showSave = view.isDirty && view.isOwned && !manageReportsOpen;
            const showReset = view.isDirty && !manageReportsOpen;
            let title = getFromStringOrFunction(view.title);
            if (title)
                title = title.length > 16 ? title.substr(0, 13) + '...' : title;
            return (React.createElement(Tab, { key: 'tab' + idx, value: view.id, label: title, onSave: showSave ? handleSave(view) : undefined, onReset: showReset ? handleReset(view) : undefined }));
        }))));
}
export default ReportsTabs;
